import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, Output} from "@angular/core";
import {Observable, Subscription} from "rxjs";
import * as _ from "lodash";
import {PANEL_DATA} from "../../services/panel.service";
import {TaskModel} from "../../../../tasks/models/task.model";
import {TaskRelationModel} from "../../../../tasks/models/task-relation.model";
import {RelationType} from "../../../types/relation.type";
import {flattenTaskRelations, isBlockedRelationType} from "../../../../tasks/utils/task-relations.util";

export interface TaskRelationsPopupData {
  relations: TaskRelationModel[];
  tasks$: Observable<TaskModel[]>;
}

export interface TaskRelationRow {
  type: RelationType;
  isBlocked: boolean;
  details: any;
  agentName?: { firstName: string; lastName: string };
}

require('./task-relations-popup.scss');
@Component({
  standalone: false,
  selector: 'app-task-relations-popup',
  templateUrl: './task-relations-popup.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskRelationsPopupComponent implements OnInit, OnDestroy {
  @Output() onClose = new EventEmitter<void>();

  public rows: TaskRelationRow[] = [];
  public loading: boolean = true;

  private _subscription: Subscription;

  constructor(
    @Inject(PANEL_DATA) public data: TaskRelationsPopupData,
    @Inject('bringozToastService') private bringozToastService,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this._subscription = this.data.tasks$.subscribe({
      next: (tasks: TaskModel[]) => {
        const freshRelations = flattenTaskRelations(tasks);

        this.rows = (this.data.relations || [])
          .map((relation): TaskRelationRow => {
            const freshRelation = _.find(freshRelations, {type: relation.type, relatedTaskId: relation.relatedTaskId});
            if (!freshRelation) {
              return undefined;
            }
            const agentName = this._resolveAgentName(freshRelation);
            return {type: relation.type, isBlocked: isBlockedRelationType(relation.type), details: freshRelation.details, agentName};
          })
          .filter(row => !!row);
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.close();
        this.bringozToastService.error({ body: 'RELATIONS_LOAD_ERROR' });
      }
    });
  }

  ngOnDestroy() {
    this._subscription?.unsubscribe();
  }

  close() {
    this.onClose.emit();
  }

  private _resolveAgentName(relation: TaskRelationModel): { firstName: string; lastName: string } | undefined {
    const details = relation.details;
    if (!details?.agentFirstName && !details?.agentLastName) {
      return undefined;
    }
    return {
      firstName: details.agentFirstName,
      lastName: details.agentLastName
    };
  }
}
